module.exports = __webpack_public_path__ + "2fa81868ef32e350f3ace8ba0c05da93.png";